import { forwardRef } from '@chakra-ui/react';
import { type ControlProps } from 'react-select';

import { CURRENT_DATE_RELATIONS, type DateRelation } from '@frontend/api';
import {
  Select,
  SelectComponents,
  type SelectProps,
} from '@frontend/components';

import type { RelationSelectorOption } from './types';

export const RelationSelectorControl = (
  props: ControlProps<RelationSelectorOption, false>,
) => {
  const [value] = props.getValue();
  return (
    <SelectComponents.Control
      {...props}
      innerProps={{
        ...props.innerProps,
        ...(value != null &&
        !CURRENT_DATE_RELATIONS.find((relation) => value.value === relation)
          ? { borderRightRadius: 0 }
          : null),
      }}
    />
  );
};

export type RelationSelectorProps<
  Relation extends DateRelation = DateRelation,
> = SelectProps<RelationSelectorOption<Relation>, false>;

const RelationSelector = forwardRef(
  <Relation extends DateRelation = DateRelation>(
    { name, components, ...rest }: RelationSelectorProps<Relation>,
    ref,
  ) => {
    return (
      <Select
        ref={ref}
        name={`${name}_relation`}
        isClearable={false}
        components={{
          Control: RelationSelectorControl,
          ...components,
        }}
        {...rest}
        isMulti={false}
      />
    );
  },
);

export default RelationSelector;
